import React from "react";

const ArrowLeftIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="28.461" height="15.547" viewBox="0 0 28.461 15.547"><path d="M1.61 301.3h22.69l-4.252 4.252a1.3 1.3 0 0 0 1.832 1.832l3.872-3.878 2.585-2.589a1.292 1.292 0 0 0 0-1.822l-6.457-6.464a1.3 1.3 0 1 0-1.832 1.832l4.262 4.252h-22.767a1.294 1.294 0 1 0 .067 2.585z" transform="translate(.002) translate(-.257 -292.234)" fill={props.fill}/></svg>
    )
}


export default ArrowLeftIcon;
